// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bi-4";
export var collapsed = "_bi-1";
export var headerBar = "_bi-0";
export var leftHeaderContent = "_bi-3";
export var subjectContainer = "_bi-2";